export const WINDOW_NAME = 'betgames_iframe';

export const UPDATE_HEIGHT_REPEAT = 5;
